import { render, staticRenderFns } from "./TerminiCondizioniCittadini.vue?vue&type=template&id=a8e63770&"
import script from "./TerminiCondizioniCittadini.vue?vue&type=script&lang=js&"
export * from "./TerminiCondizioniCittadini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports